<div class="business-tab-title">
  <div class="business-tab-title__text">
    <span class="typography-headline-2">
      <ng-content select="[title]"></ng-content>
    </span>
    <span class="typography-body-2 business-tab-title__text-subtitle">
      <ng-content select="[subtitle]"></ng-content>
    </span>
  </div>

  <div class="business-tab-title__right">
    <ng-content select="[right]"></ng-content>
  </div>
</div>
